// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","Coconut":"#F4F7FA","link":"NavigationCategories_link__wHqeV typography_fontStyleM__j9jIB","selectedTopic":"NavigationCategories_selectedTopic__CFMGS"};